import React from "react";
import Explore from "./Pages/Explore.js"
import Splash from "./Pages/Splash.js"
import Gallery from "./Pages/Gallery.js"
import Login from "./Pages/Login.js"
import Logout from "./Pages/Logout.js"
import { Router, Redirect } from "@reach/router";
import { ReactSession } from 'react-client-session';
ReactSession.setStoreType("localStorage");

function App() {
  return (
    <Router>
      <Redirect from="/" to="/hall/2w" noThrow />
      {/* <Explore path="/" /> */}
      <Explore path="/hall/:hall" location={undefined}/>
      {/* <Splash path="/"/> can be added post MVP since splash pages are just for flashiness */}
      <Gallery path="/gallery" />
      <Login path="/login" />
      <Logout path="/logout" />
    </Router>
  );
}

export default App;
